<!-- PAGE TITLE================================================== -->

<!-- <section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>Wellness I.V. Therapy</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- BANNER
        ================================================== -->
<section class="bg-banner pt-0 pb-0 banner-style03">
    <div class="hero-slider-wrapper">
        <img src="/assets/images/banner/banner4.jpeg" class="desktop-show" alt="Red Monk Wellness Banner" />
        <img src="/assets/images/banner/banner4m.jpeg" class="mobile-show" alt="Red Monk Wellness Banner" />
    </div>
</section>



<!-- 1. House of Hydration -->

<!-- <section class="section bg-blue-light">
    <div class="container">
        <div class="text-center mb-5" data-aos="fade-up">
            <h2 class="section-title">Wellness I.V. Therapy</h2>
            <p class="lead">Anti-Ageing Wellness I.V. Therapy</p>
            <p class="mt-3">Our Anti-Ageing I.V. Drips, Specially Curated to Enhance your Lifestyle & Health.</p>
        </div>

        <div class="row g-4">
            <div class="col-lg-4 col-md-6" data-aos="fade-up">
                <div class="service-card">
                    <div class="card-image" style="background-image: url('/assets/images/hoh/HOH-renew.png');">
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">HOH Renew</h4>
                        <h6 class="text-dark">Sustainable energy & reduced levels of fatigue</h6>
                        <p class="mt-3 text-muted">This drip boosts sustainable energy, combat fatigue, and restores
                            overall vitality, helping you stay active, alert, and at your best- always.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                <div class="service-card">
                    <div class="card-image" style="background-image: url('/assets/images/hoh/HOH-renainance.png');">
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">HOH Renaissance</h4>
                        <h6 class="text-dark">Peak brain performance & neural vitality</h6>
                        <p class="mt-3 text-muted">This IV drip is carefully designed to enhance focus, improve mental
                            clarity, and support optimal cognitive function.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                <div class="service-card">
                    <div class="card-image" style="background-image: url('/assets/images/hoh/HOH-RADIANCE.png');">
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">HOH Radiance</h4>
                        <h6 class="text-dark">Achieving The Natural Glow</h6>
                        <p class="mt-3 text-muted">By optimizing nutrient levels and improving blood circulation, this
                            drip enhances the quality of hair and boosts the texture, clarity & elasticity of skin from
                            within.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6" data-aos="fade-up">
                <div class="service-card">
                    <div class="card-image" style="background-image: url('/assets/images/hoh/HOH-THRYVE.png');">
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">HOH Thryve</h4>
                        <h6 class="text-dark">Energy &amp; Performance</h6>
                        <p class="mt-3 text-muted">Ignite your body’s full potential. This drip replenishes energy,
                            enhances endurance, and accelerates post-activity recovery- making you unstoppable.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                <div class="service-card">
                    <div class="card-image" style="background-image: url('/assets/images/hoh/HOH-COGNIA.png');">
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">HOH Cognia</h4>
                        <h6 class="text-dark">Elevate Your Mind</h6>
                        <p class="mt-3 text-muted">Designed to support focus, memory, and neural vitality, it helps you
                            think clearly, stay sharp, and optimize your mental performance.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                <div class="service-card">
                    <div class="card-image" style="background-image: url('/assets/images/hoh/HOH-NUVO.png');">
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">HOH Nuvo</h4>
                        <h6 class="text-dark">Anti-Aging, Skin &amp; Hair</h6>
                        <p class="mt-3 text-muted">Renew your natural radiance. This therapy nourishes cells,
                            strengthens hair, and revitalizes skin, giving you a youthful glow and lasting vitality from
                            within.</p>
                    </div>
                </div>
            </div>


        </div>
    </div>
</section> -->

<section class="section bg-blue-light">
    <div class="container">
        <div class="text-center mb-5" data-aos="fade-up">
            <h2 class="section-title">Wellness I.V. Therapy</h2>
            <p class="lead">Anti-Ageing Wellness I.V. Therapy</p>
            <p class="mt-3">Our Anti-Ageing I.V. Drips, Specially Curated to Enhance your Lifestyle & Health.</p>
        </div>       

        <div class="row g-4">
            @if (loadingItems) {
            <div class="col-12 text-center text-muted">Loading...</div>
            }
            @for (p of wellnessItems; track p.TreatmentItemID) {
            <div class="col-lg-4 col-md-6" data-aos="fade-up">
                <div class="hoh-service-card">
                    <div class="hoh-card-image pkg-shape">
                        @if (p.Image && !failedImages.has('p' + p.TreatmentItemID)) {
                        <img [src]="imgUrl(p.Image)" [alt]="p.TreatmentName" loading="lazy"
                            (error)="onImgError('p' + p.TreatmentItemID)">
                        } @else {
                        <span class="pkg-alt">{{ p.TreatmentName }}</span>
                        }
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">{{ p.TreatmentName }}</h4>
                        @if (p.Benefits) {
                        <h6 class="text-dark">{{ p.Benefits }}</h6>
                        }
                        <p class="mt-1 text-dark">{{ p.Description }}</p>
                    </div>
                </div>
            </div>
            } @empty {
            @if (!loadingItems) {
            <div class="col-12 text-center text-muted">No treatments available.</div>
            }
            }
        </div>
    </div>
</section>

<!-- 2. Origin of IV Therapy -->

<section class="section bg-light-teal">
    <div class="container">
        <div class="row align-items-center g-5">
            <div class="col-lg-5" data-aos="fade-right">
                <img src="/assets/images/hoh/origin-of-iv-therapy.jpg" alt="IV Therapy" class="img-fluid b-radius">
            </div>
            <div class="col-lg-7" data-aos="fade-left">
                <h2 class="section-title text-start">Origin of IV Therapy</h2>
                <p class="text-muted">Intravenous therapy has its roots in the medical world, dating back to the 17th
                    century, but it became widely used in modern medicine around the 20th century.</p>

                <div class="p-4 rounded-4 my-2" style="border-left: 8px solid #ee2125;">
                    <h5 class="text-danger mb-3 fw-bold"><i class="fas fa-history me-2"></i>1960s–70s</h5>
                    <p><strong>Dr. John Myers</strong>, a physician from Baltimore, popularized <strong>“Myers’
                            Cocktail”</strong> — a blend of vitamins and minerals—to treat fatigue, migraines, asthma,
                        and more. This is considered the birth of IV therapy in the wellness world.</p>
                </div>

                <h2 class="section-title text-start mt-3">Rise of Wellness I.V. Therapy (2000s onwards)</h2>

                <p class="text-muted">The shift from hospital-only use to preventive wellness and aesthetics began with
                    alternative health pioneers.</p>

            </div>
        </div>
    </div>
</section>





<!-- 3. Key Concepts -->

 <section class="section">
    <div class="container">
        <div class="text-center mb-5" data-aos="fade-up">
            <h2 class="section-title">Key Concepts</h2>
            <div class="accent-line mx-auto mt-3"></div>
        </div>
        <div class="row g-4">

            <div class="col-lg-4" data-aos="fade-up">
                <div class="key-card text-center">
                    <i class="fas fa-syringe fs-1 text-info mb-4"></i>
                    <h4>Direct Delivery</h4>
                    <p class="text-muted">Nutrients and fluids go straight into the bloodstream, allowing for 100%
                        bioavailability (maximum absorption), unlike oral supplements which can lose potency through
                        digestion.</p>
                </div>
            </div>


            <div class="col-lg-4" data-aos="fade-up" data-aos-delay="100">
                <div class="key-card text-center">
                    <i class="fas fa-flask fs-1 text-dark mb-4"></i>
                    <h4>Customized Formulas</h4>
                    <p class="text-muted">IV drips can be tailored to specific needs—like immunity boost, hydration,
                        anti-aging, detox, recovery from hangovers, fatigue, nutrient deficiencies, athletic
                        performance, etc.</p>
                </div>
            </div>

            <div class="col-lg-4" data-aos="fade-up" data-aos-delay="200">
                <div class="key-card text-center">
                    <i class="fas fa-bolt fs-1 text-warning mb-4"></i>
                    <h4>Rapid Results</h4>
                    <p class="text-muted">Because the delivery is immediate, people often feel quick improvements—such
                        as increased energy, mental clarity, or better hydration.</p>
                </div>
            </div>

        </div>
    </div>
</section> 

<!-- Dynamic -->
<!-- <section class="section">
    <div class="container">

       <div class="row g-4">
        <div
            class="col-lg-4"
            *ngFor="let concept of keyConcepts; let i = index"
            data-aos="fade-up"
            [attr.data-aos-delay]="i * 100">
            <div class="key-card text-center">
            <i
                [class]="concept.Icon + ' mb-4'">
            </i>
            <h4>
                {{ concept.Title }}
            </h4>
            <p class="text-muted">
                {{ concept.Description }}
            </p>
            </div>
        </div>
        </div>
    </div>
</section> -->


<!-- 4 How Does IV Therapy Help -->

<!-- <section class="section bg-blue">
    <div class="container">
        <div class="row align-items-center g-5">
            <div class="col-lg-5" data-aos="fade-right">
                <img src="/assets/images/hoh/benefits.jpg" alt="IV Therapy" class="benefit-image img-fluid">
            </div>
            <div class="col-lg-7" data-aos="fade-left">
                <h2 class="section-title mb-2 text-start">How does IV therapy helps</h2>
                <p class="text-dark">IV therapy helps in multiple powerful ways, depending on the formulation and goal.
                    Here's a breakdown of how and why IV therapy works, especially in wellness, recovery, and
                    performance.</p>

                <h4 class="text-dark mt-4 mb-2">Core Benefits of IV Therapy</h4>
                <ul class="list-unstyled">
                    <li class="d-flex align-items-start mb-4 text-dark">
                        <i class="fas fa-check-circle text-dark fs-4 me-3 mt-1"></i>
                        <div>
                            <strong>100% Absorption &amp; Rapid Action</strong><br>
                            <span class="text-dark">Since nutrients are delivered directly into the bloodstream, your
                                body absorbs them fully—no loss through digestion (as with oral supplements).</span>

                        </div>
                    </li>
                    <li class="d-flex align-items-start text-dark">
                        <i class="fas fa-check-circle text-dark fs-4 me-3 mt-1"></i>
                        <div>
                            <strong>Effects are faster</strong><br>
                            <span class="text-dark">Often within 30–60 minutes.</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section> -->


<!-- dynamic -->
<section class="section bg-blue" *ngFor="let s of sections">
    <div class="container">
        <div class="row align-items-center g-5">

            <div class="col-lg-5" data-aos="fade-right" *ngIf="s.imagePath">
                <img [src]="getImageUrl(s.imagePath)" [alt]="s.mainTitle || 'IV Therapy'"
                     class="benefit-image img-fluid">
            </div>

            <div [ngClass]="s.imagePath ? 'col-lg-7' : 'col-12'" data-aos="fade-left">

                <h2 class="section-title mb-2 text-start" *ngIf="s.mainTitle">
                    {{ s.mainTitle }}
                </h2>

                <p class="text-dark" *ngIf="s.mainDescription">
                    {{ s.mainDescription }}
                </p>

                <h4 class="text-dark mt-4 mb-2" *ngIf="s.subTitle">
                    {{ s.subTitle }}
                </h4>

                <ul class="list-unstyled">
                    <li *ngFor="let benefit of s.benefits"
                        class="d-flex align-items-start mb-4 text-dark">

                        <i class="fas fa-check-circle text-dark fs-4 me-3 mt-1"></i>

                        <div>
                            <strong>{{ benefit.BenefitTitle }}</strong>
                            <br>
                            <span class="text-dark">{{ benefit.BenefitDescription }}</span>
                        </div>
                    </li>
                </ul>

            </div>

        </div>
    </div>
</section>



<!-- 5 Who Should Opt For It -->

<section class="section bg-blue-light">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-7" data-aos="fade-right">
                <h2 class="section-title mb-4 text-start">Who Should Opt For IV Therapy?</h2>

                <p class="text-muted">IV therapy isn’t just for the sick anymore. It’s become a preventive and
                    performance-enhancing tool as well. Here’s a clear picture of who can benefit from IV therapy and
                    why:</p>

                <div class="candidate-card">
                    <h5 class="fw-bold text-teal">1. Busy Professionals / Burnout-Prone Individuals</h5>
                    <p><strong>Why:</strong> Long hours, poor sleep, stress, and bad eating habits lead to fatigue, low
                        immunity, and nutrient depletion.</p>
                    <p><strong>How IV helps:</strong> Replenishes energy, boosts immunity, sharpens focus.</p>

                    <hr class="my-4">

                    <h5 class="fw-bold text-teal">2. Frequent Travelers / Jet-Lagged Clients</h5>
                    <p><strong>Why:</strong> Long flights dehydrate the body and disrupt the sleep cycle.</p>
                    <p><strong>How IV helps:</strong> Rehydrates, supports immunity, improves sleep and recovery.</p>
                </div>
            </div>
            <div class="col-lg-5 mt-5 mt-lg-0" data-aos="fade-left">
                <img src="/assets/images/hoh/opt2.jpg" alt="Wellness" class="img-fluid b-radius2">
            </div>
        </div>
    </div>
</section>


<!-- 6 Why Choose RedMonk Wellness -->
<!-- 
<section class="section bg-blue">
    <div class="container">
        <div class="text-center mb-4" data-aos="fade-up">
            <h2 class="section-title">Why Choose <span class="text-danger">RedMonk Wellness</span> for IV Therapy?</h2>
            <p class=" text-muted">At Rhino, we go beyond just administering IV drips — we personalize your wellness
                journey with precision and care. What sets us apart is our commitment to clinical excellence and
                customization.</p>
        </div>
        <div class="row g-4">

            <div class="col-lg-4" data-aos="fade-up">
                <div class="why-card h-100">
                    <img src="/assets/images/hoh/ECG-Based-Diagnostics.jpg" class="w-100" alt="ECG-Based Diagnostics">
                    <div class="p-2">
                        <h5 class="fw-bold text-teal">ECG-Based Diagnostics</h5>
                        <p class="text-muted">We conduct a thorough ECG diagnostic assessment to understand your
                            cardiovascular and overall health profile before starting any IV therapy. This ensures every
                            drip is not just effective, but also safe and suitable for your body.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4" data-aos="fade-up" data-aos-delay="100">
                <div class="why-card h-100">
                    <img src="/assets/images/hoh/Tailored-IV-Formulations.jpg" class="w-100"
                        alt="Tailored IV Formulations">
                    <div class="p-2">
                        <h5 class="fw-bold text-teal">Tailored IV Formulations</h5>
                        <p class="text-muted">Based on your detailed health analysis, we design custom IV blends
                            targeting your specific goals — whether it’s enhancing performance and endurance, improving
                            skin and hair health, boosting cognitive function, or accelerating recovery. </p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4" data-aos="fade-up" data-aos-delay="200">
                <div class="why-card h-100">
                    <img src="/assets/images/hoh/Holistic-Approach.jpg" class="w-100" alt="Holistic">
                    <div class="p-2">
                        <h5 class="fw-bold text-teal">Holistic Approach</h5>
                        <p class="text-muted">Your body’s needs are unique — and so is our approach. By combining
                            diagnostic insights with evidence-based ingredients, we create a powerful and personalized
                            IV experience.
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section> -->


<!-- Dynamic -->
<!-- 6 Why Choose RedMonk Wellness (dynamic) -->
<section class="section bg-blue">
  <div class="container">

    <!-- STATIC heading -->
    <div class="text-center mb-4" data-aos="fade-up">
      <h2 class="section-title">Why Choose <span class="text-danger">RedMonk Wellness</span> for IV Therapy?</h2>
      <p class="text-muted">At Rhino, we go beyond just administering IV drips — we personalize your wellness
        journey with precision and care. What sets us apart is our commitment to clinical excellence and
        customization.</p>
    </div>

    <!-- DYNAMIC cards -->
    <div class="row g-4" data-aos="fade-up">
      <div class="col-lg-4 col-md-6" *ngFor="let card of cards; trackBy: trackByCard">
        <div class="why-card h-100">

          <div class="why-card-img">
            <img *ngIf="card.imagePath"
                 [src]="card.imagePath"
                 [alt]="card.title"
                 loading="lazy">
          </div>

          <div class="p-2">
            <h5 class="fw-bold text-teal">{{ card.title }}</h5>
            <p class="text-muted">{{ card.description }}</p>
          </div>

        </div>
      </div>
    </div>

  </div>
</section>


<!---7 Faqs start----->

<!-- <section class="faq-section">
    <div class="container">
        <div class="row align-items-center g-5">

            <div class="col-lg-5">
                <img src="/assets/images/hoh/faqs.jpg" alt="Frequently Asked Questions"
                    class="faq-image img-fluid w-100 b-radius">
            </div>

            <div class="col-lg-7">
                <div class="mb-3">
                    <span class="text-dark fw-semibold">FAQs</span>
                    <h2 class="faq-heading">Frequently Asked Questions</h2>
                    <p class="text-muted fs-5">Everything you want to know about IV Drip Therapy</p>
                </div>

                <div class="accordion" id="faqAccordion">

                    <div class="accordion-item border-0 mb-3">
                        <h2 class="accordion-header">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                data-bs-target="#q1" aria-expanded="true">
                                <span class="faq-number">01</span> What is IV Drip Therapy?
                            </button>
                        </h2>
                        <div id="q1" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
                            <div class="accordion-body">
                                IV Drip Therapy, also known as intravenous therapy or vitamin IV therapy, is a medical
                                treatment that involves delivering fluids, vitamins, minerals, and other nutrients
                                directly into the bloodstream through an intravenous drip.
                            </div>
                        </div>
                    </div>

                    <div class="accordion-item border-0 mb-3">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#q2">
                                <span class="faq-number">02</span> Is IV Drip Therapy safe?
                            </button>
                        </h2>
                        <div id="q2" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                            <div class="accordion-body">
                                Yes, IV Drip Therapy is generally safe when administered by trained healthcare
                                professionals. However, as with any medical treatment, there are potential risks, which
                                are minimized by using high-grade sterile equipment, best-in-class highly certified
                                formulations, and careful monitoring by our healthcare professionals.
                            </div>
                        </div>
                    </div>

                   
                    <div class="accordion-item border-0 mb-3">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#q3">
                                <span class="faq-number">03</span> How does IV Drip Therapy work?
                            </button>
                        </h2>
                        <div id="q3" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                            <div class="accordion-body">
                                IV Drip Therapy works by bypassing the digestive system and delivering nutrients
                                directly into the bloodstream, allowing for rapid absorption and utilization by the
                                body. This method ensures that the nutrients are immediately available for cellular
                                function and can be beneficial for hydration, immune support, energy, and overall
                                wellness.
                            </div>
                        </div>
                    </div>

                   
                    <div class="accordion-item border-0">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#q4">
                                <span class="faq-number">04</span> How long does an IV Drip Therapy session last?
                            </button>
                        </h2>
                        <div id="q4" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                            <div class="accordion-body">
                                The duration of an IV Drip Therapy session can vary depending on the specific treatment
                                plan and the individual’s needs. Sessions typically last between 30 minutes to an hour,
                                during which the IV drip is administered gradually.
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section> -->


<section class="faq-section">
    <div class="container">
        <div class="row align-items-center g-5">

            <!-- Left Side - Single Image -->
            <div class="col-lg-5">
                <img src="/assets/images/hoh/faqs.jpg"
                     alt="Frequently Asked Questions"
                     class="faq-image img-fluid w-100 b-radius">
            </div>

            <!-- Right Side - FAQ -->
            <div class="col-lg-7">

                <div class="mb-3">
                    <span class="text-dark fw-semibold">FAQs</span>

                    <h2 class="faq-heading">
                        Frequently Asked Questions
                    </h2>

                    <p class="text-muted fs-5">
                        Everything you want to know about IV Drip Therapy
                    </p>
                </div>

                <!-- Dynamic FAQ -->
               <!-- Dynamic FAQ -->
                <div class="accordion" id="faqAccordion">

                    <div
                        class="accordion-item border-0 mb-3"
                        *ngFor="let faq of faqs; let i = index">

                        <h2
                            class="accordion-header"
                            [id]="'heading' + faq.FAQID">

                            <button
                                class="accordion-button"
                                [class.collapsed]="i !== 0"
                                type="button"
                                data-bs-toggle="collapse"
                                [attr.data-bs-target]="'#faq' + faq.FAQID"
                                [attr.aria-controls]="'faq' + faq.FAQID"
                                [attr.aria-expanded]="i === 0 ? 'true' : 'false'">

                                <span class="faq-number">
                                    {{
                                        faq.QuestionNo < 10
                                            ? '0' + faq.QuestionNo
                                            : faq.QuestionNo
                                    }}
                                </span>

                                {{ faq.Question }}

                            </button>

                        </h2>

                        <div
                            [id]="'faq' + faq.FAQID"
                            class="accordion-collapse collapse"
                            [class.show]="i === 0"
                            [attr.aria-labelledby]="'heading' + faq.FAQID"
                            data-bs-parent="#faqAccordion">

                            <div class="accordion-body">
                                {{ faq.Answer }}
                            </div>

                        </div>

                    </div>

                </div>

                <!-- No FAQ message -->
                <div *ngIf="!faqs || faqs.length === 0"
                     class="text-muted">
                    No FAQs available.
                </div>

            </div>
        </div>
    </div>
</section>
<!---Faqs end----->